import React from 'react'
import { Link } from 'react-router-dom'
import PickUpAdd from './AddPickUp'
import Constant from '../../Constant'
class PickUpAddTab extends React.Component {
  state = {
    language_data: [],
  }
  componentDidMount() {
    if (
      this.props.match.params.pickupId !== undefined &&
      this.props.match.params.pickupId !== null &&
      this.props.match.params.pickupId !== 0 &&
      this.props.match.params.pickupId !== ''
    ) {
      this.setState({ pickupId: this.props.match.params.pickupId })
    }
    this.getLanguageList()
  }
  getLanguageList = () => {
    var language_data = Constant.getLanguageList()
    this.setState({
      language_data: language_data,
      language_id: language_data[0].id,
      isLoading: false,
    })
  }
  handleLanguage = (language_id) => {
    this.setState({ language_id: language_id })
  }

  render() {
    return (
      <div className="main-body">
        <div className="page-wrapper">
          <div className="page-header">
            <div className="row align-items-end">
              <div className="col-lg-8">
                <div className="page-header-title">
                  <div className="d-inline">
                    <h4>
                      {this.props.match.params.boatType} PickUp
                      {this.props.match.params.pickupId ? 'Edit' : 'Add'}
                    </h4>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="page-header-breadcrumb">
                  <ul className="breadcrumb-title">
                    <li className="breadcrumb-item">
                      <Link to="/">
                        <i className="feather icon-home"></i>{' '}
                      </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link
                        to={`/boatsmaster/${this.props.match.params.boatType}/${this.props.match.params.boatId}/pickup-lists`}
                      >
                        {this.props.match.params.boatType}PickUp List
                      </Link>
                    </li>
                    <li className="breadcrumb-item active">
                      {this.props.match.params.boatType}
                      PickUp add
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="page-body">
            <div className="row">
              <div className="col-sm-12">
                <div className="card card-border-default">
                  <div className="card-block">
                    <div className="tab-content tabs">
                      <div
                        className="tab-pane  active"
                        role="tabpanel"
                        aria-labelledby=""
                      >
                        {this.state.pickupId !== undefined &&
                        this.state.pickupId !== null &&
                        this.state.pickupId !== 0 &&
                        this.state.pickupId !== '' ? (
                          <PickUpAdd
                            goBack={this.props.history.goBack}
                            boatType={this.props.match.params.boatType}
                            boatId={this.props.match.params.boatId}
                            pickupId={this.state.pickupId}
                          />
                        ) : (
                          <PickUpAdd
                            language_id={this.state.language_id}
                            boatType={this.props.match.params.boatType}
                            boatId={this.props.match.params.boatId}
                            goBack={this.props.history.goBack}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default PickUpAddTab
